import React, { FC } from 'react'
import i18n from 'i18next'
import { shortCardNumber, money } from '../util'
import { IChipProps } from '../Bill'

const Chip: FC<IChipProps> = ({ card, onClick }) => {
  return (
    <div className='method' onClick={onClick}>
      <img className='icon' src={require('@img/payment/bankcard.png')} />
      <div className='dropdown'>
        <div className='name'>{card ? shortCardNumber(card.number) : i18n.t('pay.bankCard')}</div>
        {card && (
          <>
            {card.balance != null ? (
              <div className='info'>{i18n.t('pay.balanceN', { n: money(card.balance) })}</div>
            ) : (
              <div className='info'>{i18n.t('pay.bankCard')}</div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default Chip
